import { Check, Gift, PenLine } from "lucide-react";
import { money } from "../lib/api";

export const GiftWrapOption = ({ price, checked, onChange, message, onMessage }) => (
  <div className="space-y-3">
  <button type="button" role="checkbox" aria-checked={checked} data-testid="giftwrap-toggle" onClick={() => onChange(!checked)}
    className={`w-full text-left rounded-2xl border-2 border-[var(--ink)] p-4 flex items-center gap-3 transition-colors ${checked ? "bg-[#c8102e] text-white shadow-[4px_4px_0_#14101F]" : "bg-white hover:bg-[#ffe4ea]"}`}>
    <span className={`w-6 h-6 shrink-0 rounded-md border-2 grid place-items-center ${checked ? "bg-white border-white text-[#c8102e]" : "border-[var(--ink)]"}`}>
      {checked && <Check className="w-4 h-4" strokeWidth={3} />}
    </span>
    <Gift className="w-5 h-5 shrink-0" />
    <span className="flex-1">
      <span className="flex justify-between gap-2 font-bold"><span>Add Christmas gift wrapping</span><span className="font-mono-x">+{money(price)}</span></span>
      <span className={`block text-sm mt-0.5 ${checked ? "text-white/90" : "text-[#3b3550]"}`}>We'll wrap your order ready to go under the tree.</span>
    </span>
  </button>
  {checked && (
    <label className="block rounded-2xl border-2 border-dashed border-[#c8102e] bg-[#fff5f7] p-4" data-testid="gift-message-box">
      <span className="flex items-center justify-between gap-2 font-semibold text-sm">
        <span className="flex items-center gap-2"><PenLine className="w-4 h-4 text-[#c8102e]" /> Gift message card (free, optional)</span>
        <span className="font-mono-x text-xs text-[#5a5470]" data-testid="gift-message-count">{message.length}/200</span>
      </span>
      <textarea rows={3} maxLength={200} value={message} onChange={(e) => onMessage(e.target.value)} data-testid="gift-message-input"
        placeholder="e.g. Merry Christmas Sam! Love, Nana xx"
        className="mt-2 w-full rounded-xl border-2 border-[var(--ink)] bg-white px-3 py-2 text-base outline-none focus:shadow-[4px_4px_0_var(--pink)] transition-shadow font-serif-i text-lg" />
      <span className="block text-xs text-[#5a5470] mt-1">We'll write this on a little card tucked in with the wrapping.</span>
    </label>
  )}
  </div>
);
